import { aboutInfo } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <img
              src="https://readdy.ai/api/search-image?query=modern%20newsroom%20or%20editorial%20office%20in%20dark%20dramatic%20lighting%20with%20multiple%20monitors%20displaying%20red%20alert%20graphics%2C%20warm%20amber%20ambient%20light%2C%20professional%20yet%20mysterious%20atmosphere%2C%20cinematic%20photography%20style%2C%20no%20people&width=700&height=500&seq=about-visual-2026&orientation=landscape"
              alt="每日大赛黑料 编辑团队 关于我们"
              className="w-full h-auto rounded-2xl"
            />
          </div>
          <div className="flex-1 w-full">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
              <i className="ri-information-line"></i>
              关于我们
            </span>
            <h2 className="text-2xl md:text-3xl font-display text-foreground-950">{aboutInfo.title}</h2>
            <p className="mt-2 text-lg text-primary-500 font-semibold">{aboutInfo.subtitle}</p>
            <p className="mt-5 text-sm text-foreground-600 leading-relaxed">{aboutInfo.content}</p>

            <div className="mt-6 grid grid-cols-3 gap-4">
              {[
                { n: '200+', l: '追踪赛事' },
                { n: '5000+', l: '独家爆料' },
                { n: '100万+', l: '覆盖用户' },
              ].map((s) => (
                <div key={s.l} className="text-center p-4 rounded-lg bg-primary-50">
                  <p className="text-xl md:text-2xl font-display text-primary-500">{s.n}</p>
                  <p className="text-xs text-foreground-600 mt-1">{s.l}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}